'use client';

import { Event } from "@/app/lib/generated/graphql-types";
import { useEventList } from "@/app/features/sites/events/EventListContext";
import { Box, Divider, Stack, Typography } from "@mui/material";
import EventListItem from "@/app/features/sites/events/ui/EventListItem";
import LoadingSpinner from "@/app/__to_be_integrated/_____components/_NEW/LoadingSpinner";
import { DateTime } from "luxon";

export default function EventList() {
    const {
        isLoading,
        events,
        direction
    } = useEventList();

    const groupedEvents = events.reduce((acc: { [key: string]: Event[] }, event) => {
        const date = DateTime.fromISO(event.startsAt);
        const monthYear: string = date.toFormat("MMMM yyyy");

        if (!acc[monthYear]) {
            acc[monthYear] = [];
        }

        acc[monthYear].push(event);
        return acc;
    }, {});

    if (isLoading) {
        return <LoadingSpinner label="Veranstaltungen werden geladen ..." />;
    }

    if (events.length === 0) {
        return (
            <Stack
                sx={{
                    width: '100%',
                    padding: (theme) => theme.spacing(4, '10%'),
                    textAlign: 'center',
                }}
            >
                <Typography component="h2" variant="h3">{direction == 'forward' ? 'Aktuell sind keine Veranstaltungen geplant' : 'Keine vergangenen Veranstaltungen gefunden'}</Typography>
            </Stack>
        )
    } else {
        return (
            <Stack spacing={2} sx={{ width: '100%', padding: (theme) => theme.spacing(4, '10%') }}>
                {groupedEvents && Object.entries(groupedEvents).map(([monthYear, groupEvents]) => (
                    <Box key={monthYear}>
                        <Divider>
                            <Typography variant="h4" sx={{ marginBottom: 2, whiteSpace: 'nowrap', color: (theme) => theme.palette.text.secondary }}>{monthYear}</Typography>
                        </Divider>
                        {groupEvents.map((event, index) => (
                            <EventListItem key={index} event={event} />
                        ))}
                    </Box>
                ))}
            </Stack>
        )
    }

}
